<div *ngIf="contract" class="container-fluid" style="background: #e4f2f3;">
  <div class="row py-3">
    <div class="file-wrapper text-left offset-md-1">
      <!-- Document Info Section -->
      <div class="document-info-row d-flex flex-row align-items-start">
        <!-- Contract Type Links -->
        <div class="info-box contract-links-box" *ngIf="contract.contract_type.includes('2025 CHPP') || contract.contract_type.includes('2025 LAP')">
          <div class="box-header">
            <i-lucide [img]="Link2" class="icon"></i-lucide>
            Contract Pages
          </div>
          <div class="links-content">
            <div *ngIf="contract.contract_type.includes('2025 CHPP')" class="contract-link-item">
              <a href="https://cnvkh04.na1.hs-sales-engage.com/Ctc/ZT+23284/cNvkH04/Jll2-6qcW7Y8-PT6lZ3l7W550RCQ6VKpxPW4P37C_4KG9FsVdwh485l5r5VW1T76g83KBkj2W8rBWCL3NpzWXW3y1m4J5S5CfKW94zT0B4hxW1JW2QWRqD7dHhDlW59jcmk57GbMbVcD-7m5Dx-f3W2jMDt9220wfVW6znrRM2X9qbmW7SfY2x14TvGfW4JCttp5-MGSBV_LWzr1101mbW86dkVl5n0fxNV-jmk36Kcq5GW22QZ3k59FP_HW6gfV3q74VLh7W6P8Gh_4QB72rW1dWGJc2Gnt7PW49X3W_1vCL1cW68V5xL6vw-y4W2vcTK52V7GyJW8qlN3Z7xSWKrW9f0ln08_L1CCf93bdZg04" target="_blank" class="btn btn-sm btn-link">
                <i-lucide [img]="FileText" class="icon"></i-lucide>
                2025 CHPP Contract
                <i-lucide [img]="ExternalLink" class="icon-right"></i-lucide>
              </a>
            </div>
            <div *ngIf="contract.contract_type.includes('2025 CHPP')" class="contract-link-item">
              <a [href]="getCognito2025CHPPInterimReportURL()" target="_blank" class="btn btn-sm btn-link">
                <i-lucide [img]="FileText" class="icon"></i-lucide>
                2025 CHPP interim report form
                <i-lucide [img]="ExternalLink" class="icon-right"></i-lucide>
              </a>
            </div>
            <div *ngIf="contract.contract_type.includes('2025 CHPP')" class="contract-link-item">
              <a [href]="getCognito2025CHPPFinalReportURL()" target="_blank" class="btn btn-sm btn-link">
                <i-lucide [img]="FileText" class="icon"></i-lucide>
                2025 CHPP Final Report
                <i-lucide [img]="ExternalLink" class="icon-right"></i-lucide>
              </a>
            </div>
            <div *ngIf="contract.contract_type.includes('2025 LAP')" class="contract-link-item">
              <a href="https://cnvkh04.na1.hs-sales-engage.com/Ctc/ZT+23284/cNvkH04/Jl22-6qcW7lCdLW6lZ3lKVqM25j2MlpfhW1GXx7b84NbmQW6fWvbZ4_PG4HW8tjpMq5b5Ww3W7sBqRL6LCXn4W1rwfhk3C8XCqVVGNZN6_C3rXVz_kyj2y6ldtW3KX1C-6FlLr2W7ZMy_W4m5_SHW4bKGfG566ZvCW9ckwyy6JhGPcW8BxxvD63C0fzW4GM8R55mrMJSW95mqjj4j150hW1vgD4y7hbb8HW2pCf_q6q7xGCW6vrB2K7tVMjdM8TGkp9kWSMW1jB6MM8r6MmYVDxx1Z4pyx2JW83xN9y7-xzx6W5Tknc96x2tl5N8nxcRKgS-7Df4V3SNg04" target="_blank" class="btn btn-sm btn-link">
                <i-lucide [img]="FileText" class="icon"></i-lucide>
                2025 LAP Contract
                <i-lucide [img]="ExternalLink" class="icon-right"></i-lucide>
              </a>
            </div>
            <div *ngIf="contract.contract_type.includes('2025 LAP')" class="contract-link-item">
              <a [href]="getCognito2025LAPFinalReportURL()" target="_blank" class="btn btn-sm btn-link">
                <i-lucide [img]="FileText" class="icon"></i-lucide>
                2025 LAP Final Report
                <i-lucide [img]="ExternalLink" class="icon-right"></i-lucide>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-10 offset-md-1 mt-4">
      <ngx-title-divider title="Required Contract Documents (SECTION C)" [bold]="true"></ngx-title-divider>
    </div>
    <div class="col-md-10 offset-md-1 mt-2" style="max-height: 300px; overflow-y: scroll;">
      <div class="edi-lite-item-container">
        <div class="edi-lite-item-content">
          <div class="row">
            <div class="col-md-12" *ngIf="isCH() && currentUser.role != 'User'">
              <!-- <p><a  target="_blank" [href]="getCognitoFormUrl()">1. 2024 CHPP Interim Report form</a></p> -->
              <!-- <p><a target="_blank" [href]="getCognitoFormCHPPGrantURL()">2. CHPP Grant Final Report</a></p> -->
              <!-- <p><a target="_blank" [href]="getCognitoFormLAPGrantURL()">LAP Grant Final Report</a></p> -->
              <p><a target="_blank" [href]="getCognitoFormRelevantUrl()">{{ contract.contract_type }} Grant Final Report</a></p>
            </div>
            <div class="col-md-12">
              <div class="actions">
                <div class="m-0" *ngIf="viewType === 'supplier' && currentUser.role != 'User'">
                  <button
                    class="btn btn-success p-0 text-capitalize"
                    (click)="addSubmittedDocumentFileEventEmitter.emit()"
                  >
                    <!-- [disabled]="true" -->
                    <i class="fa fa-plus"></i>
                    Upload Document
                  </button>
                </div>
              </div>
            </div>
          </div>
          <hr />
          <ngx-po-files
            #filesSimplePO
            [companyType]="viewType"
            [hideAddButton]="true"
            [isApprovalSection]="true"
            [addFileEventEmitter]="addSubmittedDocumentFileEventEmitter"
            [enableControls]="viewType === 'supplier'"
            [purchaseOrderId]="contract?.id"
            [fileTypes]="contract.file_types"
            [defaultTag]="'$contract_documents_c'"
            [isApproveLogicEnabled]="true"
            [isInsuranceLogicEnabled]="true"
            [isListOfTypesDisplaying]="true"
            [isFileDeletionAvaliable]="viewType == 'supplier'"
          ></ngx-po-files>
        </div>
      </div>
    </div>
  </div>
</div>
